"use strict";

(function (global) {

  /**
   * Получает объект-словарь, необходимый для наполнения данными шаблона.
   * Позволяет использовать глобальную функцию L в шаблонах для перевода строк.
   *
   * @function WebAccess.templates.prepare
   * @return {object} Объект-словарь для наполнения данными шаблона.
   * @see WebAccess.templates.render
   * @since 5.0.0.4321
   */
  global.templates.prepare = function (opt_control_id) {
    var hasID = false;
    if (opt_control_id) hasID = true;

    var data = {
      "ID": $.isPlainObject(opt_control_id) ? (new Date).getTime() : opt_control_id,
      "hasID": hasID,
      "L": function () {
        return function (a) {
          return L($.trim(a));
        }
      }
    };

    if ($.isPlainObject(opt_control_id)) $.extend(data, opt_control_id);

    return data;
  };


  /**
   * Устанавливает данные для указанного шаблона.
   * Накладывает данные на указанный шаблон, генерирует html-разметку.
   *
   * @function WebAccess.templates.render
   * @param {string} templateName Путь к файлу шаблона относительно папки Site/templates
   * @param {Object} opt_data Данные для шаблона
   * @param {boolean} opt_disableCache Отключить кеширование. Возможные значения: true, false. Значение по умолчанию false
   * @param {Object} opt_sync Загружать данные синхронно
   * @param {Object} opt_partials Подшаблоны
   * @return {Deferred<Object>} Текущий объект.
   * @since 5.0.0.4213
   * @todo создать метод для синхронного запроса
   * @todo покрыть тестами
   *
   * @example
   *
   * //Добавляем данные в словарь.
   * var data = WA.TMPL.prepare();
   * data.left = 'Левая колонка';
   * data.right = 'Правая колонка';
   * data.center = 'Центральная колонка с <a href="#">html</>';
   *
   * //Добавляем данные в шаблон.
   * // layouts/3Columns.html - шаблон с тремя колонками на блоках без таблиц.
   * WA.TMPL.render("layouts/3Columns.html", data, false, false, {left: "panels/left.html" }).done(function(html) {
   *  ShowDialog(html);
   * });
   * //В результате появится окно с тремя колонками: «Левая колонка», «Правая колонка», «Центральная колонка с html».
   */
  global.templates.render = function (templateName, opt_data, opt_disableCache, opt_sync, opt_partials) {

    opt_data = opt_data || global.templates.prepare();
    opt_sync = opt_sync || false;
    var jDeferred = getCustomDeferred();

    if (arguments.length < 1) global.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");

    loadPartials(opt_partials).done(function(partials) {
      findTemplate(templateName, opt_sync, opt_disableCache).done(function (template) {
        var html = template[0].render(opt_data, partials);
        jDeferred.resolveWith(this, [html]);
      }).fail(function (err) {
        jDeferred.rejectWith(this, [err]);
      });

    }).fail(function (err) {
      jDeferred.rejectWith(this, [err]);
    });

    return jDeferred;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Пока опасаюсь делать публичным. Не описывать в документации
   * @since 5.2.0.1300
   * @ignore
   * @private
   */
  global.templates.load = function (templateName, opt_disableCache, opt_sync) {
    opt_sync = opt_sync || false;
    var jDeferred = getCustomDeferred();
    if (arguments.length < 1) global.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED");

    findTemplate(templateName, opt_sync, opt_disableCache).done(function(_template) {
      jDeferred.resolveWith(this, [_template[0]]);
    }).fail(function (err) {
      jDeferred.rejectWith(this, [err]);
    });

    return jDeferred;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Получить спец-Deferred, похожий на Ajax от jQuery
   * @inner
   * @ignore
   * @function getCustomDeferred
   */
  var getCustomDeferred = function () {
    var jDeferred = jQuery.Deferred();
    jDeferred.success = jDeferred.done;
    jDeferred.error = jDeferred.fail;
    return jDeferred;
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  /**
   * Загрузка подшаблонов.
   *
   * @function loadPartials
   * @inner
   * @param {Object} opt_partials Подшаблоны.
   * @return {Deferred<Object>} Подшаблон.
   * @see https://api.jquery.com/category/deferred-object/
   */
  var loadPartials = function (opt_partials) {
    var jDeferred = jQuery.Deferred();
    var invertedNames = _.invert(opt_partials);
    var queries = [];
    if (opt_partials && !$.isEmptyObject(opt_partials)) {

      for (var partialKey in opt_partials) {
        var partialName = opt_partials[partialKey];
        queries.push(findTemplate(partialName));
      }

      $.when.apply($, queries).done(function () {
        var partials = {};
        var args = $.makeArray(arguments);

        for (var i =0; i<args.length; i++) {
          var partial = args[i];
          partials[invertedNames[partial[1]]] = partial[0];
        }

        jDeferred.resolve(partials);
      }).fail(function(err) {
        jDeferred.resolve(err);
      });

    } else {
      jDeferred.resolve({});
    }
    return jDeferred;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Поиск шаблона во всех известных местах
   *
   * @function findTemplate
   * @inner
   * @param {string} templateName Имя шаблона.
   * @param {boolean} opt_sync Признак синхронного запроса.
   * @param {boolean} opt_disableCache Признак игнорирования кэша.
   * @return {Deferred<Object>} Найденный шаблон.
   * @see https://api.jquery.com/category/deferred-object/
   */
  var findTemplate = function (templateName, opt_sync, opt_disableCache) {
    var jDeferred = $.Deferred();
    findCompiledTemplate(templateName).done(function (template) {
      jDeferred.resolve([template, templateName]);
    }).fail(function () {
      findCachedTemplate(templateName, opt_disableCache).done(function (template) {
        jDeferred.resolve([template, templateName]);
      }).fail(function () {
        findRemoteTemplate(templateName, opt_sync, opt_disableCache).done(function (template) {
          jDeferred.resolve([template, templateName]);
        }).fail(function (err) {
          jDeferred.reject([err, templateName]);
        });
      });
    });
    return jDeferred;
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Поиск шаблона среди скомпилированных
   *
   * @function findCompiledTemplate
   * @inner
   * @param {string} templateName Имя шаблона.
   * @return {Deferred<Object>} Найденный шаблон.
   * @see https://api.jquery.com/category/deferred-object/
   */
  var findCompiledTemplate = function (templateName) {
    var result = $.Deferred();
    if (!!window.templates && templateName.indexOf('.compile.html') !== -1) {
      var template = window.templates;
      var path = templateName.replace(/\//g, '_').replace('.compile.html', '');
      if (path[0] === '_') path = path.substring(1);
      template = template[path];

      if (!!template && template.hasOwnProperty('r')) {
        result.resolve(template);
        return result;
      }
    }
    result.reject();
    return result;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Поиск шаблона среди закешированных
   *
   * @function findCachedTemplate
   * @inner
   * @param {string} templateName Имя шаблона.
   * @param {boolean} opt_disableCache Признак игнорирования кэша.
   * @return {Deferred<Object>} Найденный шаблон.
   * @see https://api.jquery.com/category/deferred-object/
   *
   */
  var findCachedTemplate = function (templateName, opt_disableCache) {
    var result = $.Deferred();
    var cached = WA.cache.getItem(templateName);
    if (!!cached && !opt_disableCache) {
      var template = Hogan.compile(cached);
      result.resolve(template);
      return result;
    }
    ;

    result.reject();
    return result;
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Поиск шаблона на сервере
   *
   * @function findRemoteTemplate
   * @inner
   * @param {string} templateName Имя шаблона.
   * @param {boolean} opt_sync Признак синхронного запроса.
   * @param {boolean} opt_disableCache Признак игнорирования кэша.
   * @return {Deferred<Object>} Найденный шаблон.
   * @see https://api.jquery.com/category/deferred-object/
   */
  var findRemoteTemplate = function (templateName, opt_sync, opt_disableCache) {
    var result = $.Deferred();
    $.ajax({ url: "templates/" + templateName, 'async': !opt_sync, 'cache': opt_disableCache }).done(function (templateText) {
      global.cache.setItem(templateName, templateText);
      var template = Hogan.compile(templateText);
      result.resolve(template);
    }).error(function (error) {
      result.reject(error);
    });

    return result;
  }


})(window.WebAccess);